module.exports = __webpack_public_path__ + "static/media/tag-dark.abf37d9d.png";